import { PartFinderReport, UpdatePartFinderReportDescriptionRequest } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { AxiosApiError } from '@/types/apiError';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PART_FINDER_ACTIVITY_QUERY_KEY } from '../part-finder-activity/query';
import { PART_FINDER_REPORT_QUERY_KEY } from './useGetPartFinderReport';
import { PART_FINDER_REPORTS_QUERY_KEY } from './query';

export const useUpdatePartFinderReportDescription = (reportId: string) => {
  const queryClient = useQueryClient();
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  return useMutation<PartFinderReport, AxiosApiError, UpdatePartFinderReportDescriptionRequest>({
    mutationFn: async data => {
      const response = await api.tenants.updatePartFinderReportDescription(tenantId, reportId, data);
      return response.data.partFinderReport;
    },
    onSuccess: updated => {
      queryClient.setQueryData<PartFinderReport>([PART_FINDER_REPORT_QUERY_KEY, reportId], updated);
      queryClient.invalidateQueries({ queryKey: [PART_FINDER_REPORTS_QUERY_KEY], exact: false });
      queryClient.invalidateQueries({ queryKey: [PART_FINDER_ACTIVITY_QUERY_KEY], exact: false });
    },
  });
};
